module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step4-pict02-full-a5f9eadb30c904e1d95172accbbd46b7.jpg";